import { CRM_PET_RULES } from "../../../services/formatResponses/crmPet";

export { CRM_PET_RULES };

export const DIAGNOSIS_RULE_OPTIONS = [
  { value: CRM_PET_RULES.ABSENT, label: "Ausentes", className: "bg-scale-100 text-scale-700" },
  { value: CRM_PET_RULES.POTENTIAL_SUBSCRIBER, label: "Possíveis assinantes", className: "bg-highlights-100 text-highlights-700" },
  { value: CRM_PET_RULES.NO_ADDITIONAL, label: "Sem adicionais", className: "bg-scale-50 text-scale-700" },
  { value: CRM_PET_RULES.NO_PRODUCT, label: "Não compram produtos", className: "bg-gray-100 text-gray-700" },
];

export const DIAGNOSIS_RULE_MAP = Object.fromEntries(
  DIAGNOSIS_RULE_OPTIONS.map((option) => [option.value, option]),
);

export const PERIOD_OPTIONS = [
  { value: "7", label: "7 dias" },
  { value: "30", label: "30 dias" },
  { value: "90", label: "90 dias" },
  { value: "custom", label: "Personalizado" },
];

export const FAILURE_POINTS = {
  tracking_not_synced: "O histórico de rastreamento ainda não está sincronizado.",
  // no_view_with_backlog: "Existem oportunidades, mas a lista ainda não foi acessada.",
  // viewed_without_contact: "A lista foi acessada sem registro de contato.",
  high_pending_backlog: "Existem pelo menos 50 contatos pendentes.",
  no_recent_use: "O CRM Pet está sem uso recente.",
  low_contact_coverage: "A cobertura de contatos está abaixo de 10%.",
};

export const FAILURE_PRIORITY = [
  "tracking_not_synced",
  "high_pending_backlog",
  "no_recent_use",
  "low_contact_coverage",
];

export const EVENT_LABELS = {
  list_viewed: "Visualização da lista",
  contact_registered: "Contatos realizados",
  contact_history_viewed: "Visualizações do histórico de contatos",
  customer_pets_viewed: "Pets do cliente consultados",
  block_toggled: "Atualizações do bloqueio de contato",
  config_viewed: "Configuração aberta",
  config_saved: "Atualizações das configurações",
  recovery_kpis_viewed: "KPIs consultados",
  recovery_attempts_viewed: "Recuperações consultadas",
};

export const USAGE_STATUS = {
  USING: { label: "Uso saudável", className: "bg-success text-zinc-50" },
  NOT_USING: { label: "Não está usando", className: "bg-error text-zinc-50" },
  LOW_USAGE: { label: "Baixa utilização", className: "bg-warning text-zinc-600" },
  STALE: { label: "Uso desatualizado", className: "bg-warning text-zinc-600" },
  NO_OPPORTUNITY: { label: "Sem oportunidade atual", className: "bg-gray-100 text-gray-700" },
};

export const RECOVERY_STATUS = {
  PENDING_CONTACT: { label: "Aguardando contato", className: "bg-warning/10 text-warning" },
  CONTACTED: { label: "Contatado", className: "bg-scale-100 text-scale-700" },
  SCHEDULED: { label: "Agendado", className: "bg-primary/10 text-primary" },
  RESCHEDULED: { label: "Reagendado", className: "bg-secondary/10 text-secondary" },
  CANCELED: { label: "Cancelado", className: "bg-error/10 text-error" },
  FINISHED: { label: "Finalizado", className: "bg-success/10 text-success" },
  EXPIRED_NO_RESULT: { label: "Expirado sem resultado", className: "bg-gray-100 text-gray-700" },
  BLOCKED: { label: "Bloqueado", className: "bg-error/10 text-error" },
  CONVERTED_WITHOUT_CONTACT: {
    label: "Convertido sem contato",
    className: "bg-highlights-100 text-highlights-700",
  },
};
